import React from 'react';

const WhySaaS = () => {
  return (
    <section id="why-saas" className="section-padding">
      <div className="container text-center">
        <div className="section-header">
          <h2 className="section-title lang-en">Why SaaS?</h2>
          <h2 className="section-title lang-ar" style={{ display: 'none' }}>لماذا نظام SaaS؟</h2>
          <div className="shape"></div>
          <p className="section-subtitle lang-en">Al-Buffia is fully cloud-based - no installs, automatic updates and secure multi-tenant setups.</p>
          <p className="section-subtitle lang-ar" style={{ display: 'none' }}>البوفية نظام سحابي بالكامل - بدون تثبيت، تحديثات تلقائية وإعداد متعدد المستأجرين آمن.</p>
        </div>

        <div className="row mt-4">
          <div className="col-md-4">
            <i className="lni-cloud-upload icon mb-3" style={{ fontSize: 'xxx-large' }}></i>
            <h4 className="lang-en">No servers needed</h4>
            <h4 className="lang-ar" style={{ display: 'none' }}>لا حاجة لخوادم</h4>
            <p className="lang-en">Sign-up and start - we host and manage everything.</p>
            <p className="lang-ar" style={{ display: 'none' }}>سجل وابدأ - نحن نستضيف وندير كل شيء.</p>
          </div>
          <div className="col-md-4">
            <i className="lni-shield icon mb-3" style={{ fontSize: 'xxx-large' }}></i>
            <h4 className="lang-en">Continuous updates & security</h4>
            <h4 className="lang-ar" style={{ display: 'none' }}>تحديثات وأمان مستمر</h4>
            <p className="lang-en">Receive new features automatically and enjoy secure backups.</p>
            <p className="lang-ar" style={{ display: 'none' }}>احصل على مزايا جديدة تلقائياً واستمتع بنسخ احتياطية آمنة.</p>
          </div>
          <div className="col-md-4">
            <i className="lni-users icon mb-3" style={{ fontSize: 'xxx-large' }}></i>
            <h4 className="lang-en">Scalable</h4>
            <h4 className="lang-ar" style={{ display: 'none' }}>مرن وقابل للتوسع</h4>
            <p className="lang-en">From small teams to large enterprises - Al-Buffia scales with you.</p>
            <p className="lang-ar" style={{ display: 'none' }}>من فرق صغيرة إلى مؤسسات كبيرة - البوفية ينمو معك.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySaaS;
